import React, { useContext, useState } from 'react';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import { Timeout } from '../../functions/functions';
import { ShowDiplomsContext } from './types';
import { useDispatch } from 'react-redux';
import { DeleteDiplomApi } from '../../redux/diploms/diplomApiCalls';
import { useParams } from 'react-router';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean,
  toggle: any,
}

const DeleteDiplomModal: React.FC<props> = ({ modal, toggle }) => {
  const { setShowSuccessMsg, selectedDiplom } = useContext(ShowDiplomsContext)

  const dispatch: any = useDispatch()
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<string[]>([])

  const { doctorId } = useParams()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response: any = await dispatch(DeleteDiplomApi(selectedDiplom._id, doctorId))

      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full p-4 mx-auto bg-white rounded-md shadow-lg" style={{ width: "600px" }}>
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <ButtonsForm loading={loading} typeBtn='Supprimer' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DeleteDiplomModal
